import React from 'react';
import Card from 'src/components/Card';
import Avatar from 'src/components/Avatar';
import Button from 'src/components/Button';
import SrDetailContact from 'src/pages/ServiceRequest/components/SrDetailContact/SrDetailContact';
import OpenContactLink from 'src/components/OpenContactLink/OpenContactLink';
import EmptyAvatar from 'src/components/EmptyAvatar/EmptyAvatar';
import './ServiceRequestAssignedToCard.scss';

interface ServiceRequestAssignedToCardProps {
  serviceRequest: any;
  loading?: boolean;
  handleStatusChange: (statusFormData: any, serviceRequestId: any) => void;
  canAssign: boolean;
}

const ServiceRequestAssignedToCard = ({
  serviceRequest,
  loading,
  handleStatusChange,
  canAssign,
}: ServiceRequestAssignedToCardProps) => {
  if (loading) {
    return (
      <Card
        title="Assigned To"
        body={
          <div className="sr-detail-card-row">
            <SrDetailContact loading name={undefined} />
          </div>
        }
      />
    );
  }

  const hasServiceProvider: boolean = Boolean(
    serviceRequest.serviceProvider?.name
  );
  const isAssignedStatus: boolean = serviceRequest.status?.name === 'Assigned';

  const assignButtonLabel: string | null = !hasServiceProvider
    ? 'Assign'
    : isAssignedStatus
      ? 'Re-assign'
      : null;

  const assignButton =
    canAssign && assignButtonLabel ? (
      <Button
        size="tiny"
        label={assignButtonLabel}
        outline="teal"
        onClick={() =>
          handleStatusChange({ name: 'Assigned' }, serviceRequest.id)
        }
      />
    ) : null;

  const title = (
    <div className="sr-detail-card-title-with-action">
      <span>Assigned To</span>
      {assignButton}
    </div>
  );

  const renderServiceProviderContent = () => {
    if (!hasServiceProvider) {
      return (
        <div className="sr-detail-card-row">
          <SrDetailContact name="Unassigned" avatar={<EmptyAvatar />} />
        </div>
      );
    }

    return (
      <div className="sr-detail-card-row">
        <SrDetailContact
          name={serviceRequest.serviceProvider.name}
          role={serviceRequest.serviceProvider.role}
          avatar={
            <Avatar
              url={serviceRequest.serviceProvider.profileImage}
              badge="service-provider"
              size={undefined}
            />
          }
        />
        {serviceRequest.serviceProvider.id && (
          <OpenContactLink
            userId={serviceRequest.serviceProvider.id}
            name={serviceRequest.serviceProvider.name}
            navOrigin={{
              kind: 'serviceRequest',
              serviceRequestId: serviceRequest.id,
            }}
          />
        )}
      </div>
    );
  };

  return <Card title={title} body={renderServiceProviderContent()} />;
};

export default ServiceRequestAssignedToCard;